import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    FormGroup,
    Typography,
    Box,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AssessmentModal = ({ open, onClose, onSubmit, companyName }) => {
    const [model, setModel] = useState('clarins_model');
    const [options, setOptions] = useState({
        noCarryOverScores: false,
        noCarryOverDocs: false,
        carryOverReviewDate: false
    });

    const handleModelChange = (event) => {
        setModel(event.target.value);
    };

    const handleOptionChange = (event) => {
        setOptions({
            ...options,
            [event.target.name]: event.target.checked
        });
    };

    const handleContinue = () => {
        onSubmit(model, options);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Start assessment</Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                {companyName && (
                    <Typography variant="subtitle1" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
                        {companyName}
                    </Typography>
                )}

                <Box sx={{ mt: 2 }}>
                    <RadioGroup value={model} onChange={handleModelChange}>
                        <FormControlLabel
                            value="clarins_model"
                            control={<Radio />}
                            label="Modèle CLARINS"
                        />
                        <FormControlLabel
                            value="clarins_maia"
                            control={<Radio />}
                            label="Modèle CLARINS_MAIA (Version 1)"
                        />
                        <FormControlLabel
                            value="basic_due_diligence"
                            control={<Radio />}
                            label="Basic due diligence"
                        />
                    </RadioGroup>
                </Box>

                <Box sx={{ mt: 4 }}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={options.noCarryOverScores}
                                    onChange={handleOptionChange}
                                    name="noCarryOverScores"
                                />
                            }
                            label="Do not carry over overridden scores"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={options.noCarryOverDocs}
                                    onChange={handleOptionChange}
                                    name="noCarryOverDocs"
                                />
                            }
                            label="Do not carry over documents & comments and overridden scores"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={options.carryOverReviewDate}
                                    onChange={handleOptionChange}
                                    name="carryOverReviewDate"
                                />
                            }
                            label="Carry over next review date"
                        />
                    </FormGroup>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleContinue}
                    variant="contained"
                    color="primary"
                    sx={{ px: 4, py: 1, backgroundColor: '#000080' }} // Dark blue color matching screenshot
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AssessmentModal;
